// extracted by mini-css-extract-plugin
export var gif = "_ga-0";